import {Component, ViewChild} from '@angular/core';
import {TableComponent} from "../../../shared/components/table/table.component";
import {BacklogService} from "../../../core/services/backlog.service";
import {GeneralService} from "../../../core/services/general.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {AddressComponent} from "./address/address.component";
import {CancelServiceComponent} from "./cancel-service/cancel-service.component";
import {ConfirmPaymentComponent} from "./confirm-payment/confirm-payment.component";
import {AssignTransferDriverComponent} from "./assign-transfer-driver/assign-transfer-driver.component";
import {AssignVehicleComponent} from "./assign-vehicle/assign-vehicle.component";

@Component({
  selector: 'app-backlog',
  standalone: true,
    imports: [
        TableComponent
    ],
  templateUrl: './backlog.component.html',
  styleUrl: './backlog.component.scss'
})
export class BacklogComponent {

  @ViewChild(TableComponent) tableComponent!: TableComponent;

  constructor(private backlogService: BacklogService, private generalService:GeneralService, private modalService: NgbModal) {
  }

  configurationTable: any = {
    "columns": [
      {
        "id": "service.id",
        "title": "Orden de servicio",
        "type": "text",
        "placeholder": "",
        "required": false,
        "hide": true
      },
      {
        "id": "service.created_at",
        "title": "Fecha",
        "type": "text",
        "placeholder": "--",
        "required": true
      },
      {
        "id": "service.passenger_name",
        "title": "Nombre cliente",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "clasificationClient.configurableListsCode",
        "title": "Clasificación cliente",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "service.passenger_phone",
        "title": "Teléfono",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "client_data.company",
        "title": "Empresa",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "service_details.service_type",
        "title": "Tipo de servicio",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "cityOrigin.configurableListsCode",
        "title": "Punto origen",
        "type": "link",
        "placeholder": "--",
        "required": false,
        "action": {
          "type": "emmit",
          "fn": this.getAddressOrigin.bind(this)
        },

      },
      {
        "id": "cityDestination.configurableListsCode",
        "title": "Punto destino",
        "type": "link",
        "placeholder": "--",
        "required": false,
        "action": {
          "type": "emmit",
          "fn": this.getAddressDestination.bind(this)
        },
      },
      {
        "id": "category_vehicle.description",
        "title": "Categoría vehiculo",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "service_details.bilingual_operator",
        "title": "Tipo conductor",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "service.start_date",
        "title": "Fecha Inicio",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "service.pickup_time",
        "title": "Horario PickUp",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "service.end_date",
        "title": "Fecha Fin",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "service.return_time",
        "title": "Horario Regreso",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "service.passenger_count",
        "title": "No de Pasajeros",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "service.airline",
        "title": "Línea aerea",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "service_details.additional_hour",
        "title": "Horas extras",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "service_details.night_event",
        "title": "Evento Nocturno",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "btnName": "Opciones",
        "actions": [
          {
            "btnName": "Confirmar pago",
            "textConfirmation": "",
            "icon":"payment",
            "action": {
              "type": "emmit",
              "fn": this.paymentConfirmation.bind(this)
            },
            "type":{
              "type":"btn-icon",
              "class": 'btn-pill btn-outline-success border border-success',
              "icons": 'credit-card',
              "condition":"assignments.payment_status_id"
            }
          },
          {
            "btnName": "Asignar trasladista",
            "textConfirmation": "",
            "icon":"stroke-form",
            "action": {
              "type": "emmit",
              "fn": this.assigntransferdriver.bind(this)
            },
            "type":{
              "type":"btn-icon",
              "class": 'btn-pill btn-outline-primary border border-primary',
              "icons": 'user-plus',
              "condition":"assignments.employee_id"
            }
          },
          {
            "btnName": "Asignar vehículo",
            "textConfirmation": "",
            "action": {
              "type": "emmit",
              "fn": this.assignVehicle.bind(this)
            },
            "type":{
              "type":"btn-icon",
              "class": 'btn-pill btn-outline-primary border border-primary',
              "icons": 'truck',
              "condition":"assignments.vehicle_id"
            }
          },
          {
            "btnName": "Cancelar servicio",
            "textConfirmation": "",
            "icon":"trash1",
            "action": {
              "type": "emmit",
              "fn": this.cancelService.bind(this)
            },
            "type":{
              "type":"btn-icon",
              "class": 'btn-pill btn-outline-danger border border-danger',
              "icons": 'trash-2'
            }
          },
        ]
      }
    ],
    "config": "backlog",
    "sortColumn": "service.id",
    "sortDirection": "DESC",
    "title": "Backlog",
    "filterPrincipal": [
    ],
    "filters":[]
  };
  public services:any = [];
  ngOnInit(){

  }

  paymentConfirmation(row:any){
    let modal = this.modalService.open(ConfirmPaymentComponent, { centered: true });
    modal.componentInstance.data = row
    modal.componentInstance.confirmAction = (data: any) => {
      if (this.tableComponent) {
        this.tableComponent.reloadTable();
      } else {
        this.generalService.showMessage('warn', 'Error! No fue posible recargar el tablero.');
      }
      modal.close();
    };
  }
  assigntransferdriver(row:any){
    let modal = this.modalService.open(AssignTransferDriverComponent, { centered: true });
    modal.componentInstance.data = row
    modal.componentInstance.confirmAction = (data: any) => {
      if (this.tableComponent) {
        this.tableComponent.reloadTable();
      } else {
        this.generalService.showMessage('warn', 'Error! No fue posible recargar el tablero.');
      }
      modal.close();
    };
  }

  assignVehicle(row:any){
    let modal = this.modalService.open(AssignVehicleComponent, { centered: true });
    modal.componentInstance.data = row
    modal.componentInstance.confirmAction = (data: any) => {
      if (this.tableComponent) {
        this.tableComponent.reloadTable();
      } else {
        this.generalService.showMessage('warn', 'Error! No fue posible recargar el tablero.');
      }
      modal.close();
    };
  }

  cancelService(row:any){
    let modal = this.modalService.open(CancelServiceComponent, { centered: true });
    modal.componentInstance.data = row
    modal.componentInstance.confirmAction = () => {
      if (this.tableComponent) {
        this.tableComponent.reloadTable();
      } else {
        this.generalService.showMessage('warn', 'Error! No fue posible recargar el tablero.');
      }
      modal.close();
    };
  }



  getAddressOrigin(row: any){
    let data = {type:'origin', data:row};
    let modal = this.modalService.open(AddressComponent, { centered: true });
    modal.componentInstance.data = data;
    modal.componentInstance.title = "Origen";
    modal.componentInstance.confirmAction = (data: any) => {
      //ToDO
    };
  }
  getAddressDestination(row: any){
    let data = {type:'destination', data:row};
    let modal = this.modalService.open(AddressComponent, { centered: true });
    modal.componentInstance.title = "Destino";
    modal.componentInstance.data = data
    modal.componentInstance.confirmAction = (data: any) => {
      //ToDO
    };
  }

}
